export * from './app-sidebar-minimizer.component';



// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/components/app-sidebar-minimizer/index.ts